export const SESSION_VALIDATE = '@komigen/mobile-frontend/authentication/SESSION_VALIDATE';

export const SESSION_EXPIRED = '@komigen/mobile-frontend/authentication/SESSION_EXPIRE';

export const SESSION_UNCHANGED = '@komigen/mobile-frontend/authentication/SESSION_UNCHANGED';

export const NO_SESSION_FOUND = '@komigen/mobile-frontend/authentication/NO_SESSION_FOUND';

export const RECAPTCHA_EXECUTE = '@komigen/mobile-frontend/authentication/RECAPTCHA_EXECUTE';

export const RECAPTCHA_CALLBACK = '@komigen/mobile-frontend/authentication/RECAPTCHA_CALLBACK';

export const RECAPTCHA_WHITELIST = '@komigen/mobile-frontend/authentication/RECAPTCHA_WHITELIST';

export const RECAPTCHA_RESET = '@komigen/mobile-frontend/authentication/RECAPTCHA_RESET';

export const REGISTRATION_BASIC_START = '@komigen/mobile-frontend/authentication/REGISTRATION_BASIC_START';

export const REGISTRATION_BASIC_FAIL = '@komigen/mobile-frontend/authentication/REGISTRATION_BASIC_FAIL';

export const REGISTRATION_BASIC_SUCCESS = '@komigen/mobile-frontend/authentication/REGISTRATION_BASIC_SUCCESS';

export const REGISTRATION_BASIC_COMPLETE = '@komigen/mobile-frontend/authentication/REGISTRATION_BASIC_COMPLETE';

export const REGISTRATION_DETAIL_START = '@komigen/mobile-frontend/authentication/REGISTRATION_DETAIL_START';

export const REGISTRATION_DETAIL_FAIL = '@komigen/mobile-frontend/authentication/REGISTRATION_DETAIL_FAIL';

export const REGISTRATION_DETAIL_SUCCESS = '@komigen/mobile-frontend/authentication/REGISTRATION_DETAIL_SUCCESS';

export const UPDATE_CREDENTIALS = '@komigen/mobile-frontend/authentication/UPDATE_CREDENTIALS';

export const ACCEPT_TERMS_AND_CONDITIONS = '@komigen/mobile-frontend/authentication/ACCEPT_TERMS_AND_CONDITIONS';

export const ACCEPT_PRIVACY_POLICY = '@komigen/mobile-frontend/authentication/ACCEPT_PRIVACY_POLICY';

export const MUST_CHANGE_PASSWORD = '@komigen/mobile-frontend/authentication/MUST_CHANGE_PASSWORD';

export const SHOULD_SHOW_MARKETING_COMMUNICATION_SETTINGS =
	'@komigen/mobile-frontend/authentication/SHOULD_SHOW_MARKETING_COMMUNICATION_SETTINGS';

export const SHOW_WELCOME_SCREEN = '@komigen/mobile-frontend/authentication/SHOW_WELCOME_SCREEN';

export const SHOW_WELCOME_POPUP = '@komigen/mobile-frontend/authentication/SHOW_WELCOME_POPUP';

export const CANCEL_LOGIN = '@komigen/mobile-frontend/authentication/CANCEL_LOGIN';

export const DISABLE_VALIDATE_SESSION = '@komigen/mobile-frontend/authentication/DISABLE_VALIDATE_SESSION';

export const ENABLE_VALIDATE_SESSION = '@komigen/mobile-frontend/authentication/ENABLE_VALIDATE_SESSION';

export const SHOW_USERNAME_PASSWORD_LOGIN = '@komigen/mobile-frontend/authentication/SHOW_USERNAME_PASSWORD_LOGIN';

export const SHOW_BANKID_LOGIN = '@komigen/mobile-frontend/authentication/SHOW_BANKID_LOGIN';

export const SHOW_PAG_LOGIN = '@komigen/mobile-frontend/authentication/SHOW_PAG_LOGIN';

export const SHOW_PHONE_LOGIN = '@komigen/mobile-frontend/authentication/SHOW_PHONE_LOGIN';

export const SET_POST_AUTH_LOCATION = '@komigen/mobile-frontend/authentication/SET_POST_AUTH_LOCATION';

export const SET_DEVICE_SESSION = '@komigen/mobile-frontend/authentication/SET_DEVICE_SESSION';

export const SET_AUTH_EXITPATH = '@komigen/mobile-frontend/authentication/SET_AUTH_EXITPATH';

export const UPDATE_ACCEPT_MARKETING_OFFERS = '@komigen/mobile-frontend/authentication/UPDATE_ACCEPT_MARKETING_OFFERS';

export const SHOW_DEPOSIT_LIMITS = '@komigen/mobile-frontend/authentication/SHOW_DEPOSIT_LIMITS';

export const REGISTRATION_PHONE_RESEND = '@komigen/mobile-frontend/authentication/REGISTRATION_PHONE_RESEND';

export const SHOW_MOJE_ID = '@komigen/mobile-frontend/authentication/SHOW_MOJE_ID';

export const MOJEID_STATUS = '@komigen/mobile-frontend/authentication/MOJEID_STATUS';

export const SET_CDD_REGISTER_STATUS = '@komigen/mobile-frontend/authentication/SET_CDD_REGISTER_STATUS';

export const TOGGLE_TRANSACTION_LINK = '@komigen/mobile-frontend/authentication/TOGGLE_TRANSACTION_LINK';

export const REGISTRATION_EXTENDED_VERIFICATION =
	'@komigen/mobile-frontend/authentication/REGISTRATION_EXTENDED_VERIFICATION';

export const AUTH_LOADING = '@komigen/mobile-frontend/authentication/AUTH_LOADING';

export const SHOW_SMS_VERIFICATION = '@komigen/mobile-frontend/authentication/SHOW_SMS_VERIFICATION';

export const MISSING_DATA_SUCCESS = '@komigen/mobile-frontend/authentication/MISSING_DATA_SUCCESS';

export const CLOSE_LUGAS_LOGIN = '@komigen/mobile-frontend/authentication/CLOSE_LUGAS_LOGIN';

export const LOAD_RECAPTCHA = '@komigen/mobile-frontend/authentication/LOAD_RECAPTCHA';

export const LOAD_SEON = '@komigen/mobile-frontend/authentication/LOAD_SEON';

export const SET_SOCIAL_LOGIN_TYPE = '@komigen/mobile-frontend/authentication/SET_SOCIAL_LOGIN_TYPE';

export const TRIGGER_FB_LOGIN = '@komigen/mobile-frontend/authentication/TRIGGER_FB_LOGIN';

export const SET_SHOULD_SHOW_MARKETING_CONSENT =
	'@komigen/mobile-frontend/authentication/SET_SHOULD_SHOW_MARKETING_CONSENT';

export const PERSIST_VALUES = '@komigen/mobile-frontend/authentication/PERSIST_VALUES';

export const CLEAR_PERSISTED_VALUES = '@komigen/mobile-frontend/authentication/CLEAR_PERSISTED_VALUES';

export const UPDATE_REGISTRATION_AB_TEST_FLOW =
	'@komigen/mobile-frontend/authentication/UPDATE_REGISTRATION_AB_TEST_FLOW';
